import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

/**
 * Inline poster body — same content as PosterA5 but rendered as a
 * sub-component so we can repeat it in multi-poster print layouts
 * (2 on A4, 4 on A3, 4 small on A4). The wrapper container drives
 * the sizing via CSS classes; this component just renders the words
 * and the QR code.
 */
export function PosterBody({ url }) {
  const displayUrl = url.replace(/^https?:\/\//, '').replace(/\?src=.*$/, '');
  return (
    <>
      <div className="tf-a5-left">
        <p className="tf-a5-eyebrow">THE FULL IMPACT</p>
        <h2 className="tf-a5-title">
          You are believed.<br />You are not alone.
        </h2>
        <p className="tf-a5-lede">
          A calm, anonymous UK guide for survivors of{' '}
          <strong>sexual violence</strong> and{' '}
          <strong>domestic abuse</strong>. Read privately in your browser —
          free, no sign-up, no tracking.
        </p>
        <ul className="tf-a5-list">
          <li>The judicial process, explained gently</li>
          <li>Your UK rights &amp; how ISVAs / IDVAs help</li>
          <li>Trauma, grounding tools &amp; a private journal</li>
          <li>Specialist helplines across England &amp; Wales</li>
        </ul>
        <div className="tf-a5-helplines">
          <p className="tf-a5-helplines-title">In immediate danger — call 999</p>
          <p className="tf-a5-helpline">Rape Crisis 24/7 · 0808 802 9999</p>
          <p className="tf-a5-helpline">Refuge (domestic abuse) 24/7 · 0808 2000 247</p>
          <p className="tf-a5-helpline">Samaritans 24/7 · 116 123</p>
          <p className="tf-a5-helpline">Live Fear Free (Wales) · 0808 80 10 800</p>
        </div>
      </div>
      <div className="tf-a5-right">
        <div className="tf-a5-qr-wrap">
          <QRCodeSVG
            value={url}
            size={220}
            level="M"
            includeMargin={false}
            bgColor="#ffffff"
            fgColor="#3F1F5B"
          />
        </div>
        <p className="tf-a5-scan-label">SCAN TO OPEN</p>
        <p className="tf-a5-url">{displayUrl}</p>
        <p className="tf-a5-badge">FREE · ANONYMOUS · TRAUMA-INFORMED</p>
      </div>
    </>
  );
}

/**
 * Multi-poster sheet — renders N copies of the poster in a grid.
 * layout controls the page size and per-poster scaling. All copies
 * share the same URL so the QR tag (?src=qr) is preserved.
 */
export default function PosterA5Multi({ url, count, layout }) {
  const cells = Array.from({ length: count });
  return (
    <aside
      className={`tf-a5-multi tf-a5-multi-${layout}`}
      aria-hidden="true"
      data-testid={`a5-multi-${layout}`}
    >
      {cells.map((_, i) => (
        <div key={i} className="tf-a5-cell">
          <div className="tf-a5-inner">
            <PosterBody url={url} />
          </div>
        </div>
      ))}
    </aside>
  );
}
